import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useSelector } from "react-redux";
import { AnnotationAvatarWithComment } from "~/components/Annotations/AnnotationsAvatarsContainer/AnnotationAvatarContainer/AnnotationAvatarWithComment";
import { PrivateAnnotationsAvatars } from "~/components/Annotations/AnnotationsAvatarsContainer/components/PrivateAnnotationsAvatars";
import { PublicAnnotationsAvatars } from "~/components/Annotations/AnnotationsAvatarsContainer/components/PublicAnnotationsAvatars";
import { getAnnotatedDiscussions } from "~/components/Annotations/AnnotationsAvatarsContainer/shared/annotationsAvatarsUtils";
import { useDiscussionPanelContextSelector } from "~/components/AssetModal/shared/context/DiscussionsPanelContext/DiscussionsPanelContext";
import { discussionsFilterSelector } from "~/components/AssetModal/shared/context/DiscussionsPanelContext/discussionsPanelContextUtils";
import { useURLShortIdSelector } from "~/hooks/useURLShortIdSelector";
import { useAnnotationContextSelector } from "~/providers/AnnotationProvider/AnnotationProvider";
import { isAnnotationsEnabledSelector } from "~/providers/AnnotationProvider/annotationProviderUtils";
import { centralizedClipVersionNumberSelector } from "~/store/centralizedClip/selectors";
import { activeDiscussionIdParamSelector } from "~/store/router/selectors";
export const AnnotationsAvatarsContainer = /*#__PURE__*/ memo((param)=>{
    let { containerWidth, containerHeight, containerLeft, containerTop, onAvatarClick, pageNumber, timestamp, hideAnnotations } = param;
    const isOnPublicRoute = !!useURLShortIdSelector();
    const activeDiscussionId = useSelector(activeDiscussionIdParamSelector);
    const versionNumber = useSelector(centralizedClipVersionNumberSelector);
    const isAnnotationsEnabled = useAnnotationContextSelector(isAnnotationsEnabledSelector);
    const discussionsFilter = useDiscussionPanelContextSelector(discussionsFilterSelector);
    const renderAnnotations = useCallback((param)=>{
        let { canReply, canShowMentionsButton, canDelete, discussions, canEdit, canResolve } = param;
        const activeDiscussion = activeDiscussionId ? discussions.find((d)=>d.id === activeDiscussionId) : null;
        let annotatedDiscussions = [];
        if (!hideAnnotations && (isAnnotationsEnabled || activeDiscussion)) {
            annotatedDiscussions = getAnnotatedDiscussions({
                discussions: activeDiscussion ? [
                    activeDiscussion
                ] : discussions,
                timestamp,
                pageNumber,
                assetVersion: versionNumber,
                filter: discussionsFilter
            });
        }
        return /*#__PURE__*/ _jsx("div", {
            className: "relative",
            style: {
                width: containerWidth,
                height: containerHeight
            },
            children: annotatedDiscussions.map((discussion)=>/*#__PURE__*/ _jsx(AnnotationAvatarWithComment, {
                    containerLeft: containerLeft,
                    containerTop: containerTop,
                    containerHeight: containerHeight,
                    containerWidth: containerWidth,
                    onAvatarClick: onAvatarClick,
                    discussion: discussion,
                    canReply: canReply,
                    canDelete: canDelete,
                    canEdit: canEdit,
                    canResolve: canResolve,
                    canShowMentionsButton: canShowMentionsButton
                }, discussion.id))
        });
    }, [
        activeDiscussionId,
        hideAnnotations,
        isAnnotationsEnabled,
        containerWidth,
        containerHeight,
        timestamp,
        pageNumber,
        versionNumber,
        discussionsFilter,
        containerLeft,
        containerTop,
        onAvatarClick
    ]);
    // TODO: compose these during fix-it week
    return isOnPublicRoute ? /*#__PURE__*/ _jsx(PublicAnnotationsAvatars, {
        renderAnnotations: renderAnnotations
    }) : /*#__PURE__*/ _jsx(PrivateAnnotationsAvatars, {
        renderAnnotations: renderAnnotations
    });
});
AnnotationsAvatarsContainer.displayName = "AnnotationsAvatarsContainer";
